import { type ValueOf } from 'type-fest';
import { Service } from 'typedi';
import Cookies from 'universal-cookie';

export const CookieName = {
  TACO: 'ccm-taco-prayer-stream',
} as const;

export type CookieNameType = ValueOf<typeof CookieName>;

@Service()
export class CookiesService {
  readonly cookies: Cookies;

  constructor() {
    this.cookies = new Cookies();
  }
}
